import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles({
  wrapper: {
    marginBottom: '17px'
  },
  label: {
    marginBottom: '22px',
    color: '#071B27',
    fontSize: 15,
    lineHeight: '12px'
  },
  radioGroup: {
    display: 'flex',
    flexDirection: 'column'
  },
  labelWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'baseline'
  },
  time: {
    width: '33%'
  },
  seats: {
    width: '33%',
    textAlign: 'center',
    color: '#838383',
    height: '18px'
  },
  duration: {
    width: '33%',
    textAlign: 'right',
    color: '#000'
  },
  radioBtnLabelChecked: {
    color: '#000000',
    fontWeight: 500
  },
  capitalize: {
    textTransform: 'capitalize'
  }
});

export const formControlLabelStyles = makeStyles({
  root: {
    marginRight: 0,
    borderBottom: '1px solid #e2ebf6',
    padding: '8px 0'
  },
  label: {
    width: '100%',
    color: '#838383'
  }
});

export const radioBtnStyles = makeStyles(theme => ({
  root: {
    color: theme.baseUI.color,
    fontSize: 18
  },
  checked: {
    color: theme.baseUI.color
  }
}));
